export default "__VITE_ASSET__8b0b291b__"